import AuthorizationCheckWarning from './AuthorizationCheckWarning'

export default AuthorizationCheckWarning
